import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Row, Col, Input, Select, Button } from 'antd';
import customerMasterDataAPI from "../../../apis/customerMasterDataAPI";
@inject('customerMasterDataStore','homeStore')
@observer
class FormModal extends Component {
  state = {
    custList: [],
  }
  formRef = React.createRef();
  componentDidMount() {
    const {customerMasterDataStore, title } = this.props
    const { detailsObj } =customerMasterDataStore
    this.getCust()

    if(title==='edit'){
      console.log(detailsObj)
      this.formRef.current.setFieldsValue({
        customer: detailsObj.customer,
        name: detailsObj.name,
        property: detailsObj.property,
        value: detailsObj.value,
        type: detailsObj.type
      })
    }
  }
  getCust =() => {
    customerMasterDataAPI.getCustAction().then(res => {
      this.setState({
        custList: res.data.data
      })
    })
  }
  handleOk=()=>{
    const {customerMasterDataStore, handleCancel, title,dataType, record } = this.props
    const { detailsObj } =customerMasterDataStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if(title==='edit'){
        if(dataType==='parameter') {
          customerMasterDataStore.onEditMasterDataAction({...fieldsValue, type: 'parameter',name:record.name, dataMappingConfigId: record.id}, detailsObj.id).then((res)=>{
            if (res && res.data && res.data.code === 0) {
              handleCancel()
            }
          })
        }else {
          customerMasterDataStore.onEditMasterDataAction({...fieldsValue, type: 'Lookup'},detailsObj.id).then((res)=>{
            if (res && res.data && res.data.code === 0) {
              handleCancel()
            }
          })
        }
        // customerMasterDataStore.onEditMasterDataAction({...fieldsValue},detailsObj.id)
      }else {
        if(dataType==='parameter') {
          customerMasterDataStore.onAddMasterDatanAction({...fieldsValue, type: 'parameter',name:record.name, dataMappingConfigId: record.id}).then((res)=>{
            if (res && res.data && res.data.code === 0) {
              handleCancel()
            }
          })
        }else {
          customerMasterDataStore.onAddMasterDatanAction({...fieldsValue, type: 'Lookup'}).then(res=>{
            if (res && res.data && res.data.code === 0) {
              handleCancel()
            }
            // customerMasterDataStore.onGetNameAction(customerValue)
          })

        }
        // customerMasterDataStore.onAddMasterDatanAction({...fieldsValue}).then(res=>{
        //   customerMasterDataStore.onGetNameAction(customerValue)
        // })
      }
    }).catch(err => {})

  }

  onChange=(value)=>{
    const { customerMasterDataStore } = this.props
    customerMasterDataStore.onChangeCustomer(value)
  }
  render() {
    const { dataType, addModalVisible, handleCancel,title } = this.props
    return (
      <>
        <Modal
          title={title==='edit'&&dataType==='parameter'?"Edit Parameter":dataType==='parameter'?"Add Parameter":title==='edit'?"Edit Master Data":"Add Master Data"}
          closable={false}
          visible={addModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type='primary' onClick={this.handleOk}>Save</Button>,
            <Button key="Cancel" onClick={handleCancel}>Cancel</Button>,
          ]}
        >
          <Form ref={this.formRef} key='addMapping'>
            <Row justify='start' gutter={[10,10]}>
              {dataType!=='parameter'?<>
                <Col xs={24} sm={24} md={24} span={24} >
                  <Form.Item name='customer' label='Customer' labelCol={{span:8}} wrapperCol={{span:14}} rules={[{ required: true, message: 'Please select Customer.'}]}>
                    <Select placeholder="Please select ..." allowClear showSearch disabled={this.props.title==='edit'}>
                      {this.state.custList.length>0 ? this.state.custList.map(item => <Select.Option key={item.id} value={item.id}>{item.customer}</Select.Option>):null}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} span={24} >
                  <Form.Item name='name' label="Name" labelCol={{span:8}} wrapperCol={{span:14}}
                             rules={[{ required: true, message: 'Please enter Name without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                    <Input maxLength={100} placeholder="Please enter ..." disabled={this.props.title==='edit'} />
                  </Form.Item>
                </Col>
              </>:null}
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='property' label="Property" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Please enter Property without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                  <Input maxLength={100} placeholder="Please enter ..." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24} >
                <Form.Item name='value' label="Value" labelCol={{span:8}} wrapperCol={{span:14}}
                           rules={[{ required: true, message: 'Please enter Value without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                  <Input maxLength={100} placeholder="Please enter ..." />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    );
  }
}

export default FormModal;
